import { ShieldCheck } from 'lucide-react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';

import { SetupWizard } from './SetupWizard';

/**
 * Shown when the merchant has no BYOK registration: they are on Tagada's
 * platform-managed Apple Pay configuration. Offers the opt-in to bring their
 * own certificates.
 */
export function PlatformDefaultState() {
  return (
    <Card>
      <CardHeader>
        <div className="flex items-center gap-2">
          <ShieldCheck className="text-muted-foreground h-5 w-5" />
          <CardTitle className="text-lg">You&apos;re using Tagada&apos;s Apple Pay</CardTitle>
        </div>
        <CardDescription>
          Apple Pay already works on your checkout using Tagada&apos;s platform configuration — nothing to set
          up. Your store appears under Tagada&apos;s name in the Apple Pay sheet.
        </CardDescription>
      </CardHeader>
      <CardContent className="space-y-4">
        <p className="text-muted-foreground text-sm">
          Want your <strong>own business name</strong> in the Apple Pay sheet, or need to use your own Apple
          merchant account for compliance? Bring your own certificates. This adds a separate, self-managed
          Apple Pay configuration for your domains and doesn&apos;t affect the platform default.
        </p>
        <SetupWizard trigger={<Button>Bring your own certificates</Button>} />
      </CardContent>
    </Card>
  );
}
